import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './ktostamm-kunde.detail-view.html',
    styleUrls: ['./ktostamm-kunde.detail-view.scss']
})
export class KtostammKundeDetailView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
